import * as types from '../const/action.types';
import { get, put, post } from '../api/_basic';

export function load(id) {
    return async (dispatch) => {
        dispatch(onboardingHasErrored(false, ''));
        dispatch(onboardingIsLoading(true));
        dispatch(loadONBOARDINGSuccess({}));
        return get(`${process.env.REACT_APP_API}/onboarding/${id}`)
            .then((response) => {
                dispatch(onboardingIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                dispatch(onboardingHasErrored(false, ''));
                dispatch(loadONBOARDINGSuccess(items));
            })
            .catch((error) => {
                dispatch(onboardingIsLoading(false));
                dispatch(onboardingHasErrored(error.type ? error.type : true, error.message));
            });
    };
}

export function loadPermission() {
    return async (dispatch) => {
        return get(`${process.env.REACT_APP_API}/maestro/permisosOnboarding`)
            .then((response) => {
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                dispatch(onboardingPermissions(items));
            })
            .catch((error) => {
                console.error(error);
            });
    };
}

export function putOnboarding(id, body) {
    return async (dispatch) => {
        dispatch(onboardingIsLoading(true));
        return put(`${process.env.REACT_APP_API}/onboarding/${id}`, body)
            .then((response) => {
                dispatch(onboardingIsLoading(false));
                return response;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function postOnboarding(id, body) {
    return async (dispatch) => {
        dispatch(onboardingIsLoading(true));
        return post(`${process.env.REACT_APP_API}/onboarding/${id}`, body)
            .then((response) => {
                dispatch(onboardingIsLoading(false));
                return response;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function loadONBOARDINGSuccess(data) {
    return {
        type: types.LOAD_ONBOARDING_SUCCESS,
        data,
    };
}

export function onboardingHasErrored(bool, message) {
    return {
        type: types.ONBOARDING_HAS_ERROR,
        hasErrored: bool,
        error: message,
    };
}

export function onboardingIsLoading(bool) {
    return {
        type: types.ONBOARDING_IS_LOADING,
        isLoading: bool,
    };
}

export function onboardingPermissions(items) {
    return {
        type: types.ONBOARDING_PERMISSIONS_SUCCESS,
        items,
    };
}



// WEBPACK FOOTER //
// ./src/actions/onboarding.actions.js